export const getSuccessRate = (
  rankLevel: number,
  crimeType: number
): number => {
  let successRate: number;
  let maxSuccessRate: number;
  let x: number;

  switch (crimeType) {
    case 0:
      successRate = 3000; // 30%
      maxSuccessRate = 8438; // 84.38%
      x = 109; // 1.09x
      break;
    case 1:
      successRate = 1500; // 15%
      maxSuccessRate = 8302; // 83.02%
      x = 113; // 1.13x
      break;
    case 2:
      successRate = 700; // 7%
      maxSuccessRate = 8663; // 86.63%
      x = 115; // 1.15x
      break;
    case 3:
      successRate = 300; // 3%
      maxSuccessRate = 8110; // 81.10%
      x = 117; // 1.17x
      break;
    default:
      return 0;
  }

  // Calculate success rate based on rank level
  for (let i = 1; i < rankLevel; i++) {
    successRate = (successRate * x) / 100;
  }

  // Cap at max success rate
  successRate = Math.min(successRate, maxSuccessRate);

  // Convert from basis points (10000 = 100%) to percentage
  return successRate / 100;
};
